module.exports = __webpack_public_path__ + "6850d0d51ac06c4c999e6fbddfba4b4f.webp";